module.exports = __webpack_public_path__ + "static/img/image1_jc.ee3893c4.jpg";